import { E, pipe, RA, TE, t } from '@packages/prelude'
import * as domain from '@packages/domain'
import { formatValidationErrors } from 'io-ts-reporters'

const makeOptionNone = (defaults: any): any => ({
  name: 'Keine Auswahl' as domain.Option.Type['name'],
  description: '',
  price: 0,
  image: defaults?.option_image_none ?? null,
  referencedStepIds: [],
  type: 'OptionNone'
})

// if allow_option_none is true, add a none option to the options array
const makeOptions = (step: any, defaults: any): ReadonlyArray<any> => {
  return pipe(
    step?.allow_option_none,
    t.withFallback(t.boolean, false).decode,
    E.map(withNone => (withNone ? RA.of<any>(makeOptionNone(defaults)) : RA.empty)),
    E.getOrElse(() => [] as ReadonlyArray<any>),
    RA.concat(step?.options),
    RA.mapWithIndex((index, option) => ({
      id: index,
      stepId: step?.id,
      name: option?.name,
      description: option?.description,
      image: option?.image,
      price: option?.price,
      category: step?.title,
      referencedStepIds: option?.referenced_step_ids ?? [],
      type: option?.type ?? 'Option'
    }))
  )
}

// Fetch configurator data from WordPress REST API
export const fetchConfiguraton = (configId: string): TE.TaskEither<Error, domain.Configurator.Type> =>
  pipe(
    TE.tryCatch(
      () => fetch(`/wp-json/wp/v2/configuration/${configId}?_embed=1`),
      () => new Error('Failed to fetch configurator data')
    ),
    TE.filterOrElse(
      response => response.ok,
      () => new Error('Failed to fetch configurator data')
    ),
    TE.chain(response =>
      TE.tryCatch(
        () => response.json(),
        () => new Error('Failed to parse configurator data')
      )
    ),
    TE.chainEitherK(data =>
      pipe(
        domain.Configurator.Type.decode({
          id: data?.id,
          slug: data?.slug,
          status: data?.status,
          type: data?.type,
          title: data?.title?.rendered,
          defaults: {
            optionImageNone: data?.defaults?.option_image_none
          },
          steps: data?.acf?.steps?.map((step: any, index: number) => ({
            id: step?.id,
            order: index,
            title: step?.title,
            description: step?.description,
            selectionMode: step?.selection_mode,
            optional: step?.optional,
            options: makeOptions(step, data?.defaults)
          }))
        }),
        E.mapLeft(errors => new Error(formatValidationErrors(errors).join('\n')))
      )
    )
  )
